// extracted by mini-css-extract-plugin
export var attachmentContainer = "_k0-0";
export var fileList = "_k0-2";
export var removeFileButton = "_k0-1";